import React from 'react';
import './style.css';

export default function({
  name,
  year,
  description,
  link,
  images
}) {
  return (
    <div className="project">
      <h2 className="project--name">{name} - ({year})</h2>
      <div className="project--description">
        {description}
      </div>
      {images && (
        images.map(i => (
          <img src={`/img/${i}`} alt="" key={i} />
        ))
      )}
      {link && (
        <a href={link} className="project--link">Learn More</a>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Project/index.jsx